var map = {
	"./Apple.svg": "d659",
	"./Corriander.svg": "ab34",
	"./Grapes.svg": "4d12",
	"./Onion.svg": "4c5a",
	"./Orange.svg": "1cbf",
	"./Potato.svg": "8b00",
	"./Spniach.svg": "f145",
	"./Strawberry.svg": "6949",
	"./kiwi.svg": "d391",
	"./watermelon.svg": "f40b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cb5a";